import { Button } from "antd";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { SwiperSlide, Swiper } from "swiper/react";
import { Autoplay } from "swiper";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../styles/superAdmin/login.css";
import { useEffect, useRef } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import axios from "axios";
import { set } from "lodash";
import LoadingSpinner from "../UI/superAdmin/loaders/LoadingSpinner";
import SuccessPopup from "../UI/superAdmin/modals/SuccessModal";
import ErrorPopup from "../UI/superAdmin/modals/ErrorModal";

const slides = [
  {
    image: "/assets/superAdmin/slider_img1.svg",
    title: "Add Client",
    description: "Manage your clients efficiently",
  },
  {
    image: "/assets/superAdmin/slider_img2.svg",
    title: "Extend Subscriptions",
    description: "Streamlined administrative controls",
  },
  {
    image: "/assets/superAdmin/slider_img3.svg",
    title: "Add Module",
    description: "Streamlined administrative controls",
  },

  {
    image: "/assets/superAdmin/slider_img4.svg",
    title: "Revenue Analytics",
    description: "Streamlined administrative controls",
  },
];

const ResetPassword = () => {
  const passwordRef = useRef(null);
  const usernameRef = useRef(null);
  const dispatch = useDispatch();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const navigate = useNavigate();
  // Extract email and token from URL
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const emailFromUrl = queryParams.get("email");
    const tokenFromUrl = queryParams.get("token");

    if (emailFromUrl) setEmail(emailFromUrl);
    if (tokenFromUrl) setToken(tokenFromUrl);
  }, [location.search]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/super-admin/reset-password?email=${email}&token=${token}`,
        {
          password,
          password_confirmation: confirmPassword,
        }
      );

      setSuccessMessage(response.data.message);

      setIsLoading(false);
      navigate(`/super_admin/login`);
    } catch (error) {
      setIsLoading(false);
      setErrorMessage(error?.response.data.message);
      return;
    }
  };

  return (
    <>
      {successMessage && (
        <SuccessPopup
          message={successMessage}
          onClose={() => setSuccessMessage(null)}
        />
      )}
      {errorMessage && (
        <ErrorPopup
          message={errorMessage}
          onClose={() => setErrorMessage(null)}
        />
      )}
      <div className="login">
        <div className="login-wrapper">
          {/* Left Section */}
          <div className="left-section d-lg-flex d-none">
            <Swiper
              modules={[Autoplay]}
              spaceBetween={30}
              slidesPerView={1}
              pagination={{ clickable: true }}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              className="login-slider"
            >
              {slides.map((slide, index) => (
                <SwiperSlide key={index}>
                  <div className="slide-content">
                    <img
                      src={slide.image || "/placeholder.svg"}
                      alt={slide.title}
                      className="slide-image"
                    />
                    <h3>{slide.title}</h3>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

          {/* Right Section */}
          <div className="right-section">
            <div className="login-content">
              <h1>SSL Super Admin Management</h1>
              <p>
                All Super administrative actions managed from one account to
                make management easier
              </p>

              <form className="super_loginForm" onSubmit={handleSubmit}>
                <h2>Reset Password</h2>
                <div className="form-wrapper">
                  <div className="input-group">
                    <label htmlFor="password">Password:</label>
                    <input
                      type={showPassword ? "text" : "password"}
                      id="password"
                      className="form-input"
                      ref={passwordRef}
                      name="passWord"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <span
                      onClick={() => setShowPassword((prev) => !prev)}
                      className="password-toggle-icon"
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "65%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        color: "#6366f1",
                      }}
                    >
                      {showPassword ? (
                        <FaEyeSlash size={20} />
                      ) : (
                        <FaEye size={20} />
                      )}
                    </span>
                  </div>

                  <div className="input-group">
                    <label htmlFor="confirm-password">Confirm Password:</label>
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      id="confirm-password"
                      className="form-input"
                      ref={passwordRef}
                      name="passWord"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                    <span
                      onClick={() => setShowConfirmPassword((prev) => !prev)}
                      className="password-toggle-icon"
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "65%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        color: "#6366f1",
                      }}
                    >
                      {showConfirmPassword ? (
                        <FaEyeSlash size={20} />
                      ) : (
                        <FaEye size={20} />
                      )}
                    </span>
                  </div>

                  <Button
                    type="primary"
                    htmlType="submit"
                    size="large"
                    className="proceed-btn"
                    isLoading={isLoading}
                  >
                    {isLoading ? <LoadingSpinner /> : "Reset Password"}
                  </Button>
                </div>
              </form>
              <div className="privacy-link">
                <Link to="#">Privacy</Link>
                <span className="separator">|</span>
                <Link to="#">Terms & conditions</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
